import { type PermissionContext } from '@ardoq/access-control';
import {
  type APIComponentAttributes,
  type APIWorkspaceAttributes,
  type ArdoqId,
} from '@ardoq/api-types';
import {
  type CurrentContext,
  type ScenarioModeState,
  type WorkspaceAndModelLookup,
} from '@ardoq/data-model';
import { type DropdownItem } from '@ardoq/dropdown-menu';
import { type FeatureContext } from '@ardoq/features';
import { type I18nLocale } from '@ardoq/i18n';
import { actionCreator } from '@ardoq/rxbeach';
import { type ContextMenuTestIds } from './consts';
import { type ReferenceCreationMenuState } from 'streams/referenceCreationMenuState$';

export type ContextMenuAppState = {
  i18nLocale: I18nLocale;
  permissionContext: PermissionContext;
  featureContext: FeatureContext;
  currentContext: CurrentContext;
  hasCollapsingRuleApplied: boolean;
  activeScenarioState: ScenarioModeState;
  loadedWorkspaceIds: ArdoqId[];
  workspacesById: Record<ArdoqId, APIWorkspaceAttributes>;
  isViewpointMode: boolean;
  workspaceAndModel: WorkspaceAndModelLookup;
  componentsById: Record<ArdoqId, APIComponentAttributes>;
  referenceCreation: ReferenceCreationMenuState;
};

export type ContextMenuRequest = {
  position: { left: number; top: number };
  testId?: ContextMenuTestIds;
  getItems: (appState: ContextMenuAppState) => DropdownItem[];
  onOpened?: VoidFunction;
};

export const contextMenuRequested = actionCreator<ContextMenuRequest>(
  '[contextMenus] CONTEXT_MENU_REQUESTED'
);
